$(function() {

  if ($('#pdf-container').length > 0) {
    // If absolute URL from the remote server is provided, configure the CORS
    // header on that server.
    var url =
      "https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf";
  
    // Loaded via <script> tag, create shortcut to access PDF.js exports.
    var { pdfjsLib } = globalThis;
  
    // The workerSrc property shall be specified.
    pdfjsLib.GlobalWorkerOptions.workerSrc =
      "//mozilla.github.io/pdf.js/build/pdf.worker.mjs";
    var pdfDoc = null,
      pageNum = 1,
      pageRendering = false,
      pageNumPending = null,
      scale = 1,
      canvas = document.getElementById("pdf-container"),
      ctx = canvas.getContext("2d");
  
    // Function to render the PDF page
    function renderPage(num) {
      pageRendering = true;
      pdfDoc
        .getPage(num)
        .then(function(page) {
          var viewport = page.getViewport({ scale: scale });
  
          // Prepare canvas using PDF page dimensions
          canvas.height = viewport.height;
          canvas.width = viewport.width;
  
          // Render PDF page into canvas context
          var renderContext = {
            canvasContext: ctx,
            viewport: viewport,
          };
          var renderTask = page.render(renderContext);
          renderTask.promise.then(function() {
            pageRendering = false;
            if (pageNumPending !== null) {
              // New page rendering is pending
              renderPage(pageNumPending);
              pageNumPending = null;
            }
          });
        })
        .catch(function(error) {
          // Handle errors here
          console.error("Error rendering page:", error);
        });
    }
  
    // Asynchronous download of PDF
    var loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(
      function(pdfDocument) {
        pdfDoc = pdfDocument;
  
        // Initial render
        renderPage(pageNum);
      },
      function(reason) {
        // PDF loading error
        console.error(reason);
      }
    );
  
      // Zoom action button
      document.getElementById('zoom-btn').addEventListener('click', function() {
          if (scale >= 1 && scale < 4) {
              scale += 3;
          } else if (scale >= 4) {
              scale = 1; // Reset scale if it exceeds 4
          }
          
          renderPage(pageNum);
      });
  }

});



// WEBPACK FOOTER //
// ./resources/js/regular/pdf.js